export default "__VITE_ASSET__BVkMYqpA__"